<script setup lang="ts">
import { InterfaceSelection } from "~/classes/entity/InterfaceSelection"
import { ReactiveFile } from "~/classes/file/ReactiveFile"

const props = defineProps({
  folderId: null
})

const { files, unwatch } = ReactiveFile.createReactiveFolderList(
  props.folderId,
  "sidebar",
  InterfaceSelection.minimumSelfSidebarSelection(),
)

onUnmounted(() => {
  unwatch()
})
</script>

<template>
  <div class="entry-file-list">
    <sidebar-entry-file
      v-for="file in files"
      :key="file.id"
      class="entry-file-list-item"
      :file
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.entry-file-list
  @apply pl-[#{$sidebar-pl-indent}]

.entry-file-list-item
  @apply mt-[#{$sidebar-gap-content-section}]
</style>
